/**
 * Scrolling Bar Component
 * Infinite horizontal scrolling animation using CSS
 */

class ScrollingBar {
  constructor(section) {
    this.section = section;
    this.track = section.querySelector('[data-scrolling-track]');
    this.content = section.querySelector('[data-scrolling-content]');
    this.speed = parseFloat(this.track?.dataset.speed) || 1;
    this.pauseOnHover = this.track?.dataset.pauseHover === 'true';

    if (this.track && this.content) {
      this.init();
    }
  }

  init() {
    this.calculateAnimationDuration();

    if (this.pauseOnHover) {
      this.track.addEventListener('mouseenter', () => this.pauseAnimation());
      this.track.addEventListener('mouseleave', () => this.resumeAnimation());
    }

    window.addEventListener('resize', () => this.calculateAnimationDuration());
  }

  calculateAnimationDuration() {
    const contentWidth = this.content.offsetWidth;
    const baseDuration = contentWidth / 50;
    const duration = baseDuration / this.speed;

    this.track.style.animationDuration = `${duration}s`;
  }

  pauseAnimation() {
    this.track.classList.add('section-scrolling-bar__track--paused');
  }

  resumeAnimation() {
    this.track.classList.remove('section-scrolling-bar__track--paused');
  }

  destroy() {
    window.removeEventListener('resize', () => this.calculateAnimationDuration());
  }
}

function initScrollingBars() {
  const sections = document.querySelectorAll('[data-section-type="w-scrolling-bar"]');
  sections.forEach(section => {
    if (!section.scrollingBarInstance) {
      section.scrollingBarInstance = new ScrollingBar(section);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initScrollingBars);
} else {
  initScrollingBars();
}

if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-section-type="w-scrolling-bar"]');
    if (section) {
      section.scrollingBarInstance = new ScrollingBar(section);
    }
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.querySelector('[data-section-type="w-scrolling-bar"]');
    if (section && section.scrollingBarInstance) {
      section.scrollingBarInstance.destroy();
      section.scrollingBarInstance = null;
    }
  });
}

// Expose class globally for dynamic initialization
window.ScrollingBar = ScrollingBar;
